import { Config } from '@/services';

export const ServerRoute = {
	auth: {
		google: '/auth/google'
	}
};

export const getServerUrl = (route: string) => {
	return `${Config.get('apiRoot')}${route}`;
};
